import { render, staticRenderFns } from "./cardMedicalCertificate.vue?vue&type=template&id=1351ce48"
import script from "./cardMedicalCertificate.vue?vue&type=script&lang=js"
export * from "./cardMedicalCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports